export const APP_ID = (process.env.REACT_APP_ENVIRONMENT === "production")
	? "192933e44662fb98"
	: "19199676890e8dea";

	export const REGION = "EU";
